import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './features/authSlice';
import localAudioReducer from './features/localAudioSlice';
import playerReducer from './features/playerSlice';
import { authApi } from './services/auth';
import { mixgenieApi, subscriptionsApi } from './services/mixgenie';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    localAudio: localAudioReducer,
    player: playerReducer,
    [authApi.reducerPath]: authApi.reducer,
    [mixgenieApi.reducerPath]: mixgenieApi.reducer,
    [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      authApi.middleware,
      mixgenieApi.middleware,
      subscriptionsApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
